import {EMobilityToolsFeatureAppComponentLibrary} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

import {Link} from './link';
import {Button, ButtonInverted} from './button';
import {ConfigureButton} from './configure-button';
import {Disclaimer} from './disclaimer';
import {DisclaimerReference} from './disclaimer-reference';
import {Icon, IconInverted} from './icon';
import {InfoButton, InfoButtonInverted} from './info-button';
import {Input} from './input';
import {Image} from './image';
import {LayerContainer} from './layer-container';
import {GroupedSelect, Select} from './select';
import {MultiSlider, Slider} from './slider';
import {Text, TextInverted} from './text';
import {Toggle} from './toggle';
import {FaqList} from './faq';
import {Flag, FlagInverted} from './flag';
import {Divider} from './divider';
import {Accordion} from './accordion';
import {Tabs} from './tabs';
import {Table} from './table';

export const ComponentsLibrary: EMobilityToolsFeatureAppComponentLibrary = {
  Accordion,
  Button,
  ButtonInverted,
  ConfigureButton,
  Disclaimer,
  DisclaimerReference,
  Divider,
  FaqList,
  Flag,
  FlagInverted,
  GroupedSelect,
  Icon,
  IconInverted,
  Image,
  InfoButton,
  InfoButtonInverted,
  Input,
  LayerContainer,
  Link,
  MultiSlider,
  Select,
  Slider,
  Table,
  Tabs,
  Text,
  TextInverted,
  Toggle,
} as unknown as EMobilityToolsFeatureAppComponentLibrary;
